module.exports = __webpack_public_path__ + "img/platform-2.8c7facc0.png";